import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import styles from "../styles/AdminSidebar.module.scss";
import { CiUser } from "react-icons/ci";
import { FiBarChart2, FiPackage, FiSettings } from "react-icons/fi";
import { TbGridPattern } from "react-icons/tb";
import { BiHome, BiLogOutCircle } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../../actions/authActions";

interface NavItem {
  labelId: string;
  path: string;
  icon: React.ReactNode;
}

const navItems: NavItem[] = [
  { labelId: "admin.sidebar.stats", path: "/admin/stats", icon: <FiBarChart2 /> },
  { labelId: "admin.sidebar.users", path: "/admin/users", icon: <CiUser /> },
  { labelId: "admin.sidebar.orders", path: "/admin/orders", icon: <FiPackage /> },
  { labelId: "admin.sidebar.patterns", path: "/admin/patterns", icon: <TbGridPattern /> },
  { labelId: "admin.sidebar.settings", path: "/admin/settings", icon: <FiSettings /> },
];

const AdminSidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();
  const handleLogout = () => {
    dispatch(logoutUser());
    navigate('/admin/login')
  }
  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <div className={styles.brand}>
          <span className={styles.brandBadge}>ADMIN</span>
          <span className={styles.brandName}>Panel</span>
        </div>

        <nav className={styles.nav}>
          {navItems.map(({ labelId, path, icon }) => (
            <NavLink
              key={path}
              to={path}
              className={({ isActive }) =>
                `${styles.navItem} ${isActive ? styles.navItemActive : ""}`
              }
            >
              <span className={styles.navIcon}>{icon}</span>
              <span className={styles.navLabel}>
                {intl.formatMessage({ id: labelId, defaultMessage: labelId })}
              </span>
              <span className={styles.navIndicator} />
            </NavLink>
          ))}
        </nav>

        <div className={styles.sidebarFooter}>
          <div className={styles.footerDivider} />
            <button
            className={`${styles.navItem} ${styles.logoutButton}`}
            onClick={() => navigate('/')}
          > <span className={styles.navIcon}><BiHome /></span>
            <span className={styles.navLabel}>{intl.formatMessage({ id: "admin.sidebar.backToHome", defaultMessage: "Back to Home" })}</span>
            <span className={styles.navIndicator} /></button>
          <button
            className={`${styles.navItem} ${styles.logoutButton}`}
            onClick={handleLogout}
          > <span className={styles.navIcon}><BiLogOutCircle /></span>
            <span className={styles.navLabel}>{intl.formatMessage({ id: "admin.sidebar.logout", defaultMessage: "Log out" })}</span>
            <span className={styles.navIndicator} /></button>
        </div>
      </aside>

      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
};

export default AdminSidebar;